import anylogger from '@app/anylogger'
import { useCurrentBreakpoint } from '@app/muiplus'
import { Box, lighten, useTheme } from '@mui/material'
import { useCallback } from 'react'
import { CalendarDisplayEvent } from './CalendarDisplayEvent'
import { parseCalendarEvent } from './calendarUtils'

const log = anylogger('CalendarEvent')

interface CalendarEventProps {
	displayEvent?: CalendarDisplayEvent
	onClick?: (e: CalendarDisplayEvent) => void
	isDetailed?: boolean
	hasMultiDaySiblings?: boolean
}
export function CalendarEvent({ displayEvent, onClick, isDetailed, hasMultiDaySiblings }: CalendarEventProps) {
	const theme = useTheme()
	let eventProps = {}
	let desc
	let bg = 'transparent'
	let cursor
	const bkp = useCurrentBreakpoint()

	const showDetails = useCallback(() => {
		if (onClick && displayEvent) onClick(displayEvent)
	}, [displayEvent, onClick])

	let { dateStr, startTime, tooltip } = parseCalendarEvent(displayEvent?.event)

	if (displayEvent && onClick) {
		const event = displayEvent.event

		cursor = 'pointer'

		if (isDetailed) tooltip = ''
		desc = event.summary
		if (bkp != 'mobile') desc = startTime + desc

		bg = lighten(theme.palette.primary.light, 0.4)

		const padding = bkp == 'mobile' ? '0.1em' : '0.25em'
		const margin = bkp == 'mobile' ? '0.1em' : '0.25em'
		eventProps = { px: padding, mx: margin }
		if (displayEvent.multiDay) {
			if (displayEvent.isFirstDay) {
				eventProps = { ...eventProps, mr: '0px', borderRadius: '0.25em 0 0 0.25em' }
			} else if (displayEvent.isLastDay) {
				eventProps = { ...eventProps, ml: '0px', borderRadius: '0 0.25em 0.25em 0' }
			} else {
				eventProps = { ...eventProps, mx: '0px' }
			}
		} else {
			eventProps = { ...eventProps, mx: margin, borderRadius: '0.25em' }
		}

		// if (bkp == 'mobile') {
		// } else {
		// 	eventProps = {
		// 		px: '0.25em',
		// 		mx: '0.25em',
		// 		textOverflow: 'ellipsis'
		// 	}
		// }
	} else desc = <br />

	return (
		<Box
			{...eventProps}
			// With many events for a single day, they seem to share the space evenly as needed, so there is no need to
			// restrict wrapping with whitespace="pre".
			whiteSpace={hasMultiDaySiblings ? 'pre' : undefined}
			// We do need overflow="hidden" to prevent causing a scroll bar for the day
			overflow="hidden"
			bgcolor={bg}
			tooltip={tooltip}
			onClick={showDetails}
			sx={{
				cursor,
				fontWeight: 'bold',
				fontSize: bkp == 'mobile' ? '0.8em' : '1em',
				lineHeight: '1.1em'
				// flexShrink: 1
			}}
		>
			{desc}
		</Box>
	)
}
